<template>
  <div class="container member-bank-form">
    <div class="common-header-wrap">
      <mt-header :title="getTitle" class="common-header">
        <mt-button slot="left" icon="back" @click="goBack"></mt-button>
      </mt-header>
    </div>
    <div class="main-content">
      <flex-line :show-border="true">
        <span>{{ $t('Account Type') }}</span>
        <div slot="right">
          <mt-radio v-model="bank_info.memberbank_type" :options="memberbank_type_options">
          </mt-radio>
        </div>
      </flex-line>
      <flex-line v-if="bank_info.memberbank_type === 'bank'" class="field-line" :show-border="true"><span
          class="field-name">Account Holder Name</span>
        <div class="field-line-right" slot="right"><input class="field-input" v-model="bank_info.memberbank_truename" />
        </div>
      </flex-line>
      <flex-line v-if="bank_info.memberbank_type === 'bank'" class="field-line" :show-border="true"><span
          class="field-name">Bank Name</span>
        <div class="field-line-right" slot="right"><input class="field-input" v-model="bank_info.memberbank_name" /></div>
      </flex-line>

      <flex-line class="field-line" style="flex-direction: column;align-items: flex-start;" :show-border="true">
        <span class="field-name" style="width: 100%;font-size: 14px;font-weight: 600;margin: .5rem 0;">
          {{ $t('USDT Address (TRC20)') }}
        </span>
        <div class="field-line-right" slot="right">
          <input class="field-input"
            style="flex: 1;width: 15rem;text-align: left;border: 1px solid #cccccc;padding: .6rem;border-radius: .4rem;"
            :placeholder="$t('Please enter')" v-model="bank_info.memberbank_no" />
        </div>
      </flex-line>

      <flex-line class="field-line" style="flex-direction: column;align-items: flex-start;" :show-border="true"
        :showPassword="showPassword" :toggleVisibility="toggleVisibility" :isPassword="true">
        <span class="field-name" style="width: 100%;font-size: 14px;font-weight: 600;margin: .5rem 0;">
          {{ $t('Payment Password') }}
        </span>

        <div class="field-line-right" slot="right">
          <input class="field-input" :type="showPassword ? 'text' : 'password'"
            style="flex: 1;line-height: 1rem;width: 15rem;text-align: left;border: 1px solid #cccccc;padding: .6rem;border-radius: .4rem;"
            :placeholder="$t('Please enter')" v-model="bank_info.member_paypwd" />
        </div>
      </flex-line>

      <flex-line class="field-line" style="flex-direction: column;align-items: flex-start;" :show-border="true"
        :showPassword="showPassword" :toggleVisibility="toggleVisibility" :isPassword="true">
        <span class="field-name" style="width: 100%;font-size: 14px;font-weight: 600;margin: .5rem 0;">
          {{ $t('Confirm Password') }}
        </span>

        <div class="field-line-right" slot="right">
          <input class="field-input" :type="showPassword ? 'text' : 'password'"
            style="flex: 1;line-height: 1rem;width: 15rem;text-align: left;border: 1px solid #cccccc;padding: .6rem;border-radius: .4rem;"
            :placeholder="$t('Please enter')" v-model="bank_info.member_paypwd_pwsd" />
        </div>
      </flex-line>

      <div class="pt-10 pb-10">
        <div class="common-btn ds-button-large" @click="submit">{{ getSumitTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getBankInfo, addBank, editBank } from '../../../api/memberBank'
import flexLine from '../../flexLine'
export default {
  components: {
    flexLine,
  },
  computed: {
    isAddMode() {
      let mode = this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle() {
      if (this.isAddMode) {
        return this.$t('Add New')
      } else {
        return this.$t('Edit') + ' ' + this.$t('Withdrawal Account')
      }
    },
    getSumitTitle() {
      return this.$t('Save')
    }
  },
  data() {
    return {
      memberbank_type_options: [
        // {
        //   label: '银行',
        //   value: 'bank'
        // },
        // {
        //   label: '支付宝',
        //   value: 'alipay'
        // }
        {
          label: 'USDT',
          value: 'usdt'
        }
      ],
      memberbank_id: 0,
      bank_info: {
        memberbank_type: 'usdt',
        memberbank_truename: '',
        memberbank_name: '',
        memberbank_no: '',
        member_paypwd: '',
        member_paypwd_pwsd: '',
      },
      showPassword: false,
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.memberbank_id = this.$route.query.memberbank_id
      getBankInfo(this.memberbank_id).then(res => {
        this.bank_info.memberbank_type = res.result.bank_info.memberbank_type
        this.bank_info.memberbank_truename = res.result.bank_info.memberbank_truename
        this.bank_info.memberbank_name = res.result.bank_info.memberbank_name
        this.bank_info.memberbank_no = res.result.bank_info.memberbank_no
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  methods: {
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    goBack() {
      if (this.$route.query.backTo == '-2') {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    submit() {
      if (this.isAddMode) {

        if (this.bank_info.member_paypwd !== this.bank_info.member_paypwd_pwsd) {
          Toast(this.$t('The confirm password does not match the entered password'))
          return
        }
        
        Indicator.open()

        addBank(this.bank_info).then(
          (response) => {
            Indicator.close()
            if (response.code === 10000) {
              Toast(this.$t('succ'))
              this.$router.go(-1)
            } else {
              Toast(response.message)
            }
            // setTimeout(() => {
            //   this.$router.push({ name: 'MemberBankList' })
            // }, 500);
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editBank(this.bank_info, this.memberbank_id).then(
          (response) => {
            Indicator.close()
            this.$router.push({ name: 'MemberBankList' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }
}
</script>
<style lang="scss">
.member-bank-form {
  .mint-radiolist {
    display: flex;

    .mint-cell {
      flex: 1;

      .mint-radio-input:checked+.mint-radio-core {
        background-color: $primaryColor !important;
        border-color: $primaryColor !important;
      }

      &:after {
        display: none
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.main-content {
  background: #fff;
  padding: 0 $pageSpace
}

.right-arrow {
  transform: rotate(-90deg);
  color: #ddd;
  font-size: $fontSize;
  display: inline-block;
}

.input-wrap {
  position: relative;

  i {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 2.4rem;
    display: block;
    width: 2rem;
    text-align: center;
    font-size: $h1
  }
}
</style>
